module.exports = __webpack_public_path__ + "static/media/bus.11cb05e6.svg";